import constants from '@/app-configs/constants'

export default [
  {
    title: 'DEBTIA_API_TOKENS',
    icon: 'MoreVerticalIcon',
    action: constants.action.permissionApiTokenList,
    resource: constants.resource.apiToken,
    children: [
      {
        title: 'DEBTIA_TOKENS',
        route: 'api-tokens',
        action: constants.action.permissionApiTokenList,
        resource: constants.resource.apiToken,
      },
    ],
  },
]
